<template>
  <a-modal
    v-model="visible"
    :width="isStandard ? '1100px' : '984px'"
    :title="title"
    :footer="null"
    centered
    class="chooseAddress"
    @ok="confirm"
  >
    <div class="content-info">
      <a-form-model layout="horizontal" :model="form">
        <a-row type="flex">
          <a-col :span="isStandard ? 12 : 10">
            <a-form-model-item
            label="地址信息"
            :colon="false"
            :label-col="{span: isStandard ? 3 : 5}"
            :wrapper-col="{span: isStandard ? 20 : 18}">
              <a-input
              v-model="form.multiLike"
              :placeholder="inputPlaceHolder"
              @pressEnter="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="2">
            <a-form-model-item :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button type="primary" @click="onSearch">
                查询
              </a-button>
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="margin-top:10px">
            <a-checkbox v-model="checked">最近使用</a-checkbox>
          </a-col>
        </a-row>
      </a-form-model>
      <a-table
        :columns="tableColumns"
        row-key="id"
        :data-source="data"
        :scroll="{ x: 'calc(700px + 50%)'}"
        :pagination="checked?false:pagination"
        :loading="loading.fetchData"
        class="table-multip"
        :custom-row="handleRowClick"
        :row-selection="rowSelection"
        @change="handleTableChange"
      >
        <template slot="name" slot-scope="name"> {{ name }} {{ name }} </template>
        <template slot="stationName" slot-scope="text">
          <a-tooltip>
            <template slot="title">{{text}}</template>
            <span class="overlength ellipsis2">{{text}}</span>
            </a-tooltip>
        </template>
        <template slot="stationAddress" slot-scope="text,record">
          <a-tooltip>
            <template slot="title">{{stationAddress(record)}}</template>
            <span class="overlength ellipsis2">{{stationAddress(record)}}</span>
            </a-tooltip>
        </template>
        <template slot="action" slot-scope="text,record">
          <a v-if="currentCustomerCode === record.customerCode" v-auth="$_ButtonPermission.SITEMANAGEMENT_EDIT" class="btn_link" @click="handleEdit(record.stationCode)">编辑</a>
          <a v-auth="$_ButtonPermission.SITEMANAGEMENT_STATUS" class="btn_link" @click="handleStop(record)">停用</a>
        </template>
      </a-table>
    </div>
    <p v-auth="$_ButtonPermission.SITEMANAGEMENT_ADD" :class="checked?'tipsText-new':'tipsText'">
      没有想要的地址？<a-button class="addTips" type="link" @click="handleEdit()">新建地址</a-button>
    </p>
    <!-- <addAddressDialog ref="addAddressDialog" v-bind="$props" @update="onSearch()"/> -->
    <create-site ref="siteForm" @refresh="handleRefresh" />
    <div class="site-footer">
      <a-button class="cancel" @click="hide">取消</a-button>
      <a-button type="primary" @click="handleConfirm">确定</a-button>
    </div>
  </a-modal>
</template>

<script>
import loadingMixin from '@thales/loading'

import { mapState } from 'vuex'
import {formatNullData} from "@/utils/util"
import {STATION_RULE_PARAMS} from '@/constants/ruleConfig'
import { getStationList,getStationListV2, getStartAll, getZeroCarLine, getManyZeroCarLine } from '../api';
import { StationTypes,StatusMap,BizType } from '../constant';
import CreateSite from '../../setting/siteMmanagement/list/components/CreateSite.vue'

const StationTypesText = {
  0: '取货点',
  1: '送货点',
  2: '取货点/送货地',
};
const columns = [
  {
    title: '地址',
    dataIndex: 'stationAddress',
    width: 235,
    scopedSlots: { customRender: "stationAddress" },
  },
  {
    title: '姓名',
    dataIndex: 'contacts',
    ellipsis: true,
    width: 100
  },
  {
    title: '电话',
    dataIndex: 'telPhone',
    ellipsis: true,
    width: 140,
  },
];

const stationTypeColumns = [
   {
    title: '站点编码',
    dataIndex: 'stationCode',
    ellipsis: true,
    width: 160,
  },
  {
    title: '客户站点编码',
    dataIndex: 'customerStationCode',
    ellipsis: true,
    width: 150,
  },
   {
    title: '服务商',
    dataIndex: 'tenantName',
    ellipsis: true,
    width: 150,
  },
  {
    title: '地址类型',
    dataIndex: 'stationType',
    ellipsis: true,
    customRender: (stationType) => {
      return StationTypesText[stationType]
    },
    width: 150,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: "action" },
    width: 140,
    fixed:'right'
  },
]

const stationColumns = [
  {
    title: '站点名称',
    scopedSlots: { customRender: "stationName" },
    dataIndex: 'stationName',
    width: 150,
  },
]

export default {
  name: 'SelectAddressDialog',
  components: {
   CreateSite
  },
  filters: {
    siteType(val) {
      return val === 2 ? '取' : '收'
    }
  },
  mixins: [loadingMixin],
  props: {
    stationType: {
      type: [String, Number],
      default: ''
    },
    isStandard: { // 是否标准下单时的引用
      type: Boolean,
      default: false
    },
  },
  inject: ['order'],
  data() {
    return {
      loading: {
        fetchData: false
      },
      StationTypes,
      visible: false,
      title: '请选择地址',
      form: {
      },
      data: [],
      columns,
      isWarehouse: false,
      ownerTenantId: '',
      provinceCodes: [],
      cityCodes: [],
      provinceFlag: false,
      bizType: null,
      customerCode: '',
      isPretend: false,
      isWharehose: false,
      currentCustomerCode:null,
      checked:false, // 是否最近使用
      pagination:{
        pageSize:5
      },
      isSupportBatch: false,
      selectedRowKeys: [], // Check here to configure the default column
      selectedRows: [],
    };
  },
  computed: {
    ...mapState('orderRules', ['orderRules']),
    // 标准下单时placeholder增加 站点名称/站点编码/客户站点编码
    inputPlaceHolder() {
      const placeholder = '请输入姓名/手机号/地址关键字'
      return this.isStandard ? `${placeholder}/站点名称/站点编码/客户站点编码` : placeholder
    },
    // 标准下单列表增加 站点名称/站点编码/客户站点编码
    tableColumns() {
      // if (this.isStandard) {
      //   return [...stationColumns, ...columns, ...stationTypeColumns]
      // }
      return [...stationColumns,...columns, ...stationTypeColumns]
    },
    buttonItemLayout() {
      const { layout } = this.form;
      return layout === 'horizontal'
        ? {
            wrapperCol: { span: 14, offset: 4 },
          }
        : {};
    },
    stationAddress(){
      return (row)=>{
         const { address, cityName, countyName, provinceName } = row
         return provinceName + cityName + countyName + address
      }
    },
    rowSelection() {
      if(this.isSupportBatch) {
        return { selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange }
      }
      return null
    }
  },
  watch: {
    visible(show) {
      if (!show) {
        this.form.multiLike = ''
      }
      this.checked=false
    },
    checked:{
      handler(val){
        if(!val){
          this.pagination={
            pageSize:5,
            current:1,
            total:0
          }
        }
        this.onSearch()
      },
      immediate:true
    }
  },
  methods: {
    handleConfirm(){
      this.$emit('onBatchSelectAddress', this.selectedRows)
      this.hide()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows
    },
    handleEdit(stationCode){
      this.$refs.siteForm.show(stationCode,'drawer',true)
    },
    handleStop(record){
     this.$refs.siteForm.update(record.stationCode,0)
    },
    handleRefresh(){
      this.fetchData()
    },
    async getStartAll(){
      const res = await getStartAll({})
      if(res && res.length > 0){
        this.provinceCodes = [];
        this.cityCodes = [];
        res.forEach((e) => {
          this.provinceCodes.push(e.startProvinceCode)
          this.cityCodes.push(e.startCityCode)
        })
      }
      this.fetchWmsData(true)
    },
    async getEndAll(startCityCode){
      let res = null
      if(this.isPretend){
        // 多装多卸 多个起始地
        res = getManyZeroCarLine({startCityCodes: startCityCode})
      } else {
        res = await getZeroCarLine({startCityCode})
      }
      if(res && res.length > 0){
        this.provinceCodes = [];
        this.cityCodes = [];
        res.forEach((e) => {
          this.provinceCodes.push(e.endProvinceCode)
          this.cityCodes.push(e.endCityCode)
        })
      }
      this.fetchWmsData(true)
    },
    handleRowClick(record) {
      if(this.isSupportBatch) {
        return {}
      }
      return {
        on: {
          dblclick: () => {
            this.$emit('onSelectAddress', record)
            this.hide()
          }
        }
      };
    },
    onSearch() {
      this.pagination.current = 1
      if(this.isWarehouse){
        this.fetchWmsData()
      } else if(this.provinceFlag){
        this.fetchWmsData(true)
      } else {
        this.fetchData()
      }
    },
    async fetchData() {
      const {customerCode,tenantId} = this.$store.state.user
      this.form=formatNullData(this.form)
      let params={
         ...this.form,
        stationType:this.stationType,
        status: StatusMap.ENABLED,
        bizTypes:[BizType.TRANSPORT,BizType.TRANSPORT_WAREHOUSE],
        deleteStatus:false,
      }
      if(!this.isWharehose){
        const {scope} = this.orderRules.STATION_RANGE;
        params = {...params, ...STATION_RULE_PARAMS(scope)}
      }else{
        params.tenantIds=[this.ownerTenantId,tenantId]
        params.customerCodes=[customerCode]
      }
      // 最近的
      if(this.checked){
        const data=await getStationListV2(params)
        this.data=data.map(t => ({
          ...t,
          contactInfos: t.contactInfos && t.contactInfos.length > 0 ? t.contactInfos : [{
            contacts: t.contacts,
            telPhone:t.telPhone
          }]
        }));
        this.pagination = {
          ...this.pagination,
          total:data.length,
          current: 1,
          showTotal:()=>{}
        }
        return
      }
      // 之前的情况
      const { records, total, page, size } = await getStationList({...params}, {
        size: this.pagination.pageSize,
        page: this.pagination.current,
        sort: 'updateTime__DESC'
      })
      this.data = records;
      this.pagination = {
        ...this.pagination,
        total,
        current: page,
        pageSize: size,
        showTotal: sum => `每页${ size }条 共 ${ sum } 条`
      }
    },
    confirm() {
      this.hide()
    },
    show({data = false, ownerTenantId = '', mileage = false, customerCode = '', bizType = undefined, startCityCode = null, isPretend = false, isWharehose = false}, isSupportBatch=false) {
      this.isSupportBatch = isSupportBatch
      this.visible = true
      this.isWarehouse = data
      this.ownerTenantId = ownerTenantId
      this.bizType = bizType
      this.customerCode = customerCode
      this.pagination.current = 1
      this.isPretend = isPretend;
      this.checked=false;
      this.isWharehose = isWharehose // 是否是仓订单，仓订单不会根据白名单过滤
      if(data){
        this.fetchWmsData(false)
      } else if(mileage){
        // 需要计算里程范围
        this.provinceFlag = true
        if(startCityCode){
          this.getEndAll(startCityCode)
        } else {
          this.getStartAll()
        }
      } else {
        this.fetchData(bizType)
      }
      // 保存当前登录的货主code
      this.currentCustomerCode =this.$store.state.user.customerCode;
    },
    async fetchWmsData(flag = false){
      const {customerCode,tenantId} = this.$store.state.user
      this.form=formatNullData(this.form)
      let formData = {
        ...this.form,
        tenantIds:[this.ownerTenantId,tenantId],
        bizTypes:[...Object.values(BizType)],
        stationType: this.stationType,
        status: StatusMap.ENABLED,
        customerCodes:[this.customerCode||customerCode],
        deleteStatus:false,
      }
      if(this.stationType==='RECEIVING'&&this.isWharehose){
        formData.customerCodes.push(customerCode)
      }
      if(this.stationType === 'SHIPPING'&&this.isWharehose&&this.isWarehouse){
        formData.customerCodes.push(customerCode)
      }
      if(flag){
        // 计算里程范围传入地址code
        formData.provinceCodes = this.provinceCodes
        formData.cityCodes = this.cityCodes
        if(!this.isWharehose){
          const {tenantIds,...restParams}=formData
          formData={...restParams}
        }
      } else {
        // formData.ownerTenantId = this.ownerTenantId
        // formData.bizType = 'TRANSPORT_WAREHOUSE'
      }
      if(this.checked){
         const data=await getStationListV2(formData)
        this.data=data.map(t => ({
          ...t,
          contactInfos: t.contactInfos && t.contactInfos.length > 0 ? t.contactInfos : [{
            contacts: t.contacts,
            telPhone:t.telPhone
          }]
        }));
        this.pagination = {
          ...this.pagination,
          total:data.length,
          current: 1,
          showTotal:()=>{}
        }
        return
      }
      const { records, total, page, size } = await getStationList(formData, {
        size: this.pagination.pageSize,
        page: this.pagination.current,
        sort: 'updateTime__DESC'
      })
      this.data = records;
      this.pagination = {
        ...this.pagination,
        total,
        current: page,
        pageSize: size,
        showTotal: sum => `每页${ size }条 共 ${ sum } 条`
      }
    },
    hide() {
      this.visible = false
      this.isSupportBatch = false
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      if(this.isWarehouse){
        this.fetchWmsData()
      } else if(this.provinceFlag){
        this.fetchWmsData(true)
      } else {
        this.fetchData()
      }
    },
    handleAdd() {
      if(this.ownerTenantId){
        this.$refs.addAddressDialog.show(true)
      } else {
        this.$refs.addAddressDialog.show()
      }
    }
  },
}
</script>
<style lang="less" scope>
.chooseAddress {
  /deep/ .ant-table-tbody {
    .ant-table-row {
      td {
        overflow-wrap: anywhere;
      }
    }
  }
  /deep/ .ant-table-placeholder{
  border-bottom: none !important;
  }
}
.content-info{
  max-height: 700px;
  overflow: auto;
}
.tipsText{
  color: #aaaaaa;
  font-size: 14px;
  position: absolute;
  z-index: 999;
  bottom: 48px;
  left: 25px;
  .addTips{
    color: #06b880;
    cursor: pointer;
    text-decoration: underline #06b880;
  }
}
.tipsText-new{
  color: #aaaaaa;
  font-size: 14px;
  margin-top:10px;
  .addTips{
    color: #06b880;
    cursor: pointer;
    text-decoration: underline #06b880;
  }
}
.btn_link {
  margin-left: 10px;
}
.overlength {
   text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.site-footer {
  display: flex;
  justify-content: flex-end;
  .cancel {
    margin-right: 12px;
  }
}
</style>
